import React, { useCallback, useState } from 'react'
import { Container, Css } from '@pmi/pmi-iqos-ds-react'
import { Routes, goToRoute } from '@pmi/pmi-iqos-shared-react'
import AutocompleteCss from '@algolia/autocomplete-theme-classic'
import AutocompleteCSSOverride from './autocomplete-css-override'
import Autocomplete from './autocomplete'
import { RecommendedSection } from './ui'
import { setScrolls, IndexNameTypes, RECOMMENDED_CONTENT_ID } from './utils'
import { DcxAnalytics } from '@dcx-common/services'

const AutocompleteSearchComp = ({
  translations,
  searchClient,
  sourcesConfiguration,
  initialQuerySuggestionsHits,
  recommendedContent,
  spiceIdHash
}) => {
  const [currentQuery, setCurrentQuery] = useState('')
  const [noResultsState, setNoResultsState] = useState({})

  const autocompleteOnStateChange = useCallback(({ state }) => {
    // Store the current query value
    setCurrentQuery(state.query)

    // Setup horizontal scroll to required sources
    sourcesConfiguration.forEach(s => {
      if (s.indexName === IndexNameTypes.PRODUCTS) {
        setScrolls(s.indexId)
      }
    })
    setScrolls(null, `#${RECOMMENDED_CONTENT_ID}`)
  }, [])

  const autocompleteOnSubmit = useCallback(({ query }) => {
    if (query) {
      DcxAnalytics.searchInitiatedEvent(query)
      goToRoute({
        mainPath: Routes.searchPage,
        params: [`query=${encodeURIComponent(query)}`]
      })
    }
  }, [])

  const updateNoResultsState = useCallback(state => {
    setNoResultsState(state)
  }, [])

  const showRecommendedSection = () => {
    if (currentQuery) {
      // If no results found, show recommended section
      return Object.keys(noResultsState)
        .map(key => noResultsState[key])
        .every(Boolean)
    }
    return true
  }

  return (
    <Container
      layout={Container.layouts.mid}
      px={['0', '8', '36']}
      pt={['0', '2', '5']}>
      {/* Default CSS */}
      <Css global={AutocompleteCss.toString()} />
      {/* Override CSS */}
      <AutocompleteCSSOverride sourcesConfiguration={sourcesConfiguration} />
      <Container>
        <Autocomplete
          searchClient={searchClient}
          sourcesConfiguration={sourcesConfiguration}
          onStateChange={autocompleteOnStateChange}
          onSubmit={autocompleteOnSubmit}
          updateNoResultsState={updateNoResultsState}
          translations={translations}
          spiceIdHash={spiceIdHash}
        />
        {showRecommendedSection() ? (
          <RecommendedSection
            recommendedContent={recommendedContent}
            translations={translations}
            initialQuerySuggestionsHits={initialQuerySuggestionsHits}
            currentQuery={currentQuery}
          />
        ) : null}
      </Container>
    </Container>
  )
}

export default AutocompleteSearchComp
